import { showAllThemesAndItems } from "slices/discovery/discoverySlice";

export const showSelectedLoadThemes = (showAll) => (dispatch) =>
  new Promise((resolve, reject) => {
    try {
      dispatch(showAllThemesAndItems(showAll));
      resolve();
    } catch (error) {
      reject(error);
    }
  });
